<template>
  <h2 :class="['dash-title', wrapperClass]">
    {{ text }}
  </h2>
</template>
<script>
export default {
  name: 'DashTitle',
  props: {
    text: {
      type: String,
      required: true
    },
    wrapperClass: {
        type: String,
        default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>